import React from 'react';
import { getTheme } from '../../theme';
import * as echarts from 'echarts';
import { LaunchParamsContext } from '../../launchParamsContext';


export const useChart = (ref: React.RefObject<HTMLDivElement | null>) => {
  const lp = React.useContext(LaunchParamsContext);
  const [chart, setChart] = React.useState<echarts.ECharts | null>(null);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }
    setChart((c) => {
      if (!c) {
        return echarts.init(ref.current, getTheme(lp));
      }
      return c;
    })
  }, [ref, setChart, lp]);

  return chart;
}
